import type { IThrottleObserver } from '@/utils/typescript/IThrottleObserver';

/**
 * throttle function allows to control function execution timing.
 * For example you could set a throttle on a function that could be used
 * to resize an element inside a loop event like camera position resize element or else.
 * Function will ensure that the callback is executed only once in the given time frame.
 * @param { function } callback callback function to execute on time out
 * @param { number } time timing of the setTimeout -> milliseconds
 * @param { Object } objectBoolObserver booleand used to safe guard the callback execution
 * @returns { function } throttled function that accepts arguments
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle<T extends any[]>(callback: (...args: T) => any, time: number, objectBoolObserver: IThrottleObserver) {
    return (...args: T) => {
        if (objectBoolObserver.throttleTimer) {
            return;
        }
        objectBoolObserver.throttleTimer = true;
        setTimeout(() => {
            callback(...args);
            objectBoolObserver.throttleTimer = false;
        }, time);
    };
}

export { throttle };
